(function () {

    'use strict';

    angular.module('iplusjs.fahrzeugsuche.komfort', [
        'lodash',
        'fuzzysort',
        'angulartics',
        'iplusjs.tag',
        'iplusjs.list.simple',
        'iplusjs.list.table',
        'iplusjs.button.link',
        'iplusjs.fahrzeugsuche',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsFahrzeugsucheKomfort', {
            bindings: {
                initModel: '<ifkModel',
                onSelect: '&ifkOnSelect',
                onChange: '&ifkOnChange',
                onClose: '&ifkOnClose'
            },
            templateUrl: 'common/fahrzeugsuche/fahrzeugsucheKomfort.html',
            controller: FahrzeugsucheKomfortController,
            controllerAs: 'fzgsucheKomfortVm'
        });

    FahrzeugsucheKomfortController.$inject = [
        '$log',
        '$analytics',
        'lodash',
        'FahrzeugsucheService',
        'fuzzysort',
        'MiscUtilsService'
    ];
    function FahrzeugsucheKomfortController($log, $analytics, _, FahrzeugsucheService, fuzzysort, MiscUtilsService) {
        var vm = this,
            merkmalBezeichnungen = {
                hersteller: 'Hersteller',
                typ: 'Fahrzeugtyp',
                kraftstoff: 'Kraftstoffart',
                kategorie: 'Fahrzeugkategorie',
                tueren: 'Anzahl Türen',
                leistung: 'Leistung',
                ergebnis: 'Suchergebnis'
            };

        vm.$onInit = onInit;
        vm.setMerkmalEintrag = setMerkmalEintrag;
        vm.setFahrzeug = setFahrzeug;
        vm.close = close;
        vm.getTitel = getTitel;
        vm.setCurrentMerkmal = setCurrentMerkmal;
        vm.isMerkmalDisabled = isMerkmalDisabled;
        vm.navigateBackwards = navigateBackwards;
        vm.isBackwardsNavigationVisible = isBackwardsNavigationVisible;
        vm.isErgebnisVisible = isErgebnisVisible;
        vm.clearSearch = clearSearch;
        vm.search = search;
        vm.isFuzzySearchVisible = isFuzzySearchVisible;

        function activate() {
            vm.model = FahrzeugsucheService.getModelKomfortsuche(vm.initModel);
            vm.current = FahrzeugsucheService.getCurrentListeUndMerkmalKomfortsuche(vm.model) || {};
            vm.ergebnisListeColumns = [{
                attr: ['hsn', 'tsn'],
                header: 'HSN/TSN'
            }, {
                attr: ['modell'],
                header: 'Modell'
            }, {
                attr: ['prodZeitraum'],
                header: 'Baujahr'
            }];
            suche();
        }
        function suche() {
            vm.isLoading = true;

            vm.onChange({
                model: vm.model
            });

            FahrzeugsucheService.komfortsuche(vm.model).then(function (ergebnis) {
                vm.model = ergebnis.suchergebnis;
                vm.current = FahrzeugsucheService.getCurrentListeUndMerkmalKomfortsuche(ergebnis.suchergebnis);
                vm.currentOrig = _.cloneDeep(vm.current);
            }).catch(function (error) {
            }).finally(function () {
                vm.isLoading = false;
            });
        }
        function onInit() {
            activate();
        }
        function setMerkmalEintrag(merkmalEintrag) {
            merkmalEintrag = merkmalEintrag || {};

            vm.model[vm.current.merkmal] = merkmalEintrag;
            vm.searchTerm = null;
            suche();
        }
        function setFahrzeug(fahrzeug) {
            $analytics.eventTrack('link', {
                target: 'Fahrzeugsuche-Komfort-Uebernehmen'
            });

            vm.onSelect({
                fahrzeug: fahrzeug
            });
        }
        function close() {
            vm.onClose();
        }
        function getTitel() {
            return merkmalBezeichnungen[_.get(vm.current, 'merkmal')];
        }
        function setCurrentMerkmal(merkmal) {
            vm.current.merkmal = merkmal;
            vm.current.liste = {};
            FahrzeugsucheService.resetModelKomfortsuche(vm.model, merkmal);
            vm.searchTerm = null;
            suche();
        }
        function isMerkmalDisabled(merkmal) {
            return _.size(_.get(vm.model, merkmal + 'Liste')) === 1;
        }
        function navigateBackwards() {
            var merkmalIsDisabled = true,
                previousMerkmal = vm.current.merkmal;

            while (merkmalIsDisabled) {
                previousMerkmal = FahrzeugsucheService.getPreviousMerkmalKomfortsuche(previousMerkmal);

                merkmalIsDisabled = isMerkmalDisabled(previousMerkmal);
            }

            setCurrentMerkmal(previousMerkmal);
        }
        function isBackwardsNavigationVisible() {
            return !FahrzeugsucheService.isErstesMerkmalKomfortsuche(vm.current.merkmal);
        }
        function isErgebnisVisible() {
            return vm.current.merkmal === 'ergebnis';
        }
        function clearSearch() {
            _.set(vm.current, 'liste.meistgewaehlte', _.get(vm.currentOrig, 'liste.meistgewaehlte'));
            _.set(vm.current, 'liste.alle', _.get(vm.currentOrig, 'liste.alle'));
            vm.searchTerm = null;
        }
        function search(searchTerm) {
            if (MiscUtilsService.isEmpty(searchTerm)) {
                _.set(vm.current, 'liste.meistgewaehlte', _.get(vm.currentOrig, 'liste.meistgewaehlte'));
                _.set(vm.current, 'liste.alle', _.get(vm.currentOrig, 'liste.alle'));
                return;
            }

            var fuzzySearchResult = fuzzysort.go(searchTerm, _.get(vm.currentOrig, 'liste.alle'), {
                    key: 'display',
                    threshold: -145000
                }),
                alleListe = [];

            _.forEach(fuzzySearchResult, function (el) {
                var obj = _.cloneDeep(el.obj);
                _.set(obj, 'displayHtml', el.highlight('<strong>', '</strong>'));
                alleListe.push(obj);
            });

            _.set(vm.current, 'liste.meistgewaehlte', []);
            _.set(vm.current, 'liste.alle', alleListe);
        }

        function isFuzzySearchVisible() {
            return _.includes([
                'hersteller',
                'typ'
            ], _.get(vm.current, 'merkmal')) || MiscUtilsService.isEmpty(_.get(vm.current, 'merkmal'));
        }
    }
})();
